import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from '../api';
import './CierreTurno.css';

const EditarCierreTurno = () => {
    const { id } = useParams();
    const history = useHistory();
    const [cierre, setCierre] = useState(null);
    const [originalCierre, setOriginalCierre] = useState(null); // Para comparar cambios    
    const [showConfirmacion, setShowConfirmacion] = useState(false);
    const [cambios, setCambios] = useState({});

    useEffect(() => {
        const fetchCierre = async () => {
            try {
                const response = await axios.get(`/cierres/${id}`);
                setCierre(response.data);
                setOriginalCierre(response.data); // Guarda una copia original
            } catch (error) {
                console.error('Error al obtener el cierre:', error);
                alert('Error al cargar los datos');
            }
        };
        fetchCierre();
    }, [id]);

    const getCambios = () => {
        const cambiosDetectados = {};
        Object.keys(cierre).forEach(key => {
            if (cierre[key] !== originalCierre[key]) {
                cambiosDetectados[key] = {
                    anterior: originalCierre[key],
                    nuevo: cierre[key]
                };
            }
        });
        return cambiosDetectados;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const cambiosDetectados = getCambios();
        if (Object.keys(cambiosDetectados).length > 0) {
            let mensaje = 'Vas a Modificar los siguientes campos:\n';
            for(const[campo,valores] of Object.entries(cambiosDetectados)){
                mensaje += `${campo.replace(/_/g, ' ').toUpperCase()}: Anterior: ${valores.anterior}, Nuevo: ${valores.nuevo}\n`;
            }
            mensaje += '¿Deseas continuar?';
            const confirmado = window.confirm(mensaje);
            if(confirmado){
                await confirmarGuardado();//Llama a la función para guardar los cambios
            }else{
                alert('No se han detectado cambios');
            }
        }
    };

    const confirmarGuardado = async () => {
        try {
            await axios.patch(`/cierres/${id}`, cierre);
            setShowConfirmacion(false);
            history.push('/Planillas/modificarecaudo', { cierre });
        } catch (error) {
            console.error('Error al actualizar:', error);
            alert('Error al actualizar el cierre');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCierre(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const formatFecha = (fecha) => {
        if (!fecha) return '';
        return new Date(fecha).toLocaleString('es-CO', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    if (!cierre) return <div>Cargando...</div>;

    return (
        <div className="editar-cierre-container">
            <h2>Editar Cierre de Turno ID {id}</h2>
            <form onSubmit={handleSubmit} className="editar-form">
                <div className="form-row">
                    <div className="form-group">
                        <label>Terminal:</label>
                        <input
                            type="text"
                            name="cod_terminal"
                            value={cierre.cod_terminal}
                            onChange={handleChange}
                            className="form-control"
                            readOnly
                            disabled
                        />
                    </div>
                    <div className="form-group">
                        <label>Código Parqueadero:</label>
                        <input
                            type="text"
                            name="cod_park"
                            value={cierre.cod_park}
                            onChange={handleChange}
                            className="form-control"
                            readOnly
                            disabled
                        />
                    </div>
                    <div className="form-group">
                        <label>Código Empleado:</label>
                        <input
                            type="text"
                            name="cod_empleado"
                            value={cierre.cod_empleado}
                            onChange={handleChange}
                            className="form-control"
                            readOnly
                            disabled
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Fecha Inicial:</label>
                        <input
                            type="text"
                            name="fecha_inicial"
                            value={formatFecha(cierre.fecha_inicial)}
                            className="form-control"
                            readOnly
                            disabled
                        />
                    </div>
                    <div className="form-group">
                        <label>Fecha Final:</label>
                        <input
                            type="text"
                            name="fecha_final"
                            value={formatFecha(cierre.fecha_final)}
                            className="form-control"
                            readOnly
                            disabled
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Factura Inicial:</label>
                        <input
                            type="text"
                            name="factura_ini"
                            value={cierre.factura_ini}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label>Factura Final:</label>
                        <input
                            type="text"
                            name="factura_fin"
                            value={cierre.factura_fin}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Total Efectivo:</label>
                        <input
                            type="number"
                            name="total_efectivo"
                            value={cierre.total_efectivo}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label>Total TC:</label>
                        <input
                            type="number"
                            name="total_tc"
                            value={cierre.total_tc}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Total Mensuales EF:</label>
                        <input
                            type="number"
                            name="total_mensuales_ef"
                            value={cierre.total_mensuales_ef}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label>Total Mensuales TC:</label>
                        <input
                            type="number"
                            name="total_mensuales_tc"
                            value={cierre.total_mensuales_tc}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>IVA Efectivo:</label>
                        <input
                            type="number"
                            name="iva_efectivo"
                            value={cierre.iva_efectivo}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label>IVA Datáfono:</label>
                        <input
                            type="number"
                            name="iva_datafono"
                            value={cierre.iva_datafono}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Notas Crédito:</label>
                        <input
                            type="number"
                            name="notas_credito"
                            value={cierre.notas_credito}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label>Reportado:</label>
                        <input
                            type="text"
                            name="reportado"
                            value={cierre.reportado}
                            onChange={handleChange}
                            className="form-control"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>Estado:</label>
                        <select
                            name="estado"
                            value={cierre.estado}
                            onChange={handleChange}
                            className="form-control"
                        >
                            <option value="ACTIVO">ACTIVO</option>
                            <option value="INACTIVO">INACTIVO</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Transmitido:</label>
                        <select
                            name="transmitido"
                            value={cierre.transmitido}
                            onChange={handleChange}
                            className="form-control"
                        >
                            <option value="S">SÍ</option>
                            <option value="N">NO</option>
                        </select>
                    </div>
                </div>

                <div className="form-buttons">
                    <button type="submit" className="guardar-btn">Guardar Cambios</button>
                    <button 
                        type="button" 
                        className="cancelar-btn"
                        onClick={() => history.push('/Planillas/modificarecaudo')}
                    >
                        Cancelar
                    </button>
                </div>
            </form>

            {showConfirmacion && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-lg p-6 max-w-lg w-full">
                        <h3 className="text-lg font-semibold mb-4">Confirmar cambios</h3>
                        <div className="max-h-96 overflow-y-auto">
                            {Object.entries(cambios).map(([campo, valores]) => (
                                <div key={campo} className="mb-3 p-2 bg-gray-50 rounded">
                                    <p className="font-medium">{campo.replace(/_/g, ' ').toUpperCase()}:</p>
                                    <div className="grid grid-cols-2 gap-2 mt-1 text-sm">
                                        <p className="text-red-600">Anterior: {valores.anterior}</p>
                                        <p className="text-green-600">Nuevo: {valores.nuevo}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="flex justify-end gap-4 mt-6">
                            <button
                                onClick={() => setShowConfirmacion(false)}
                                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={confirmarGuardado}
                                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                            >
                                Confirmar cambios
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EditarCierreTurno;
